import React from 'react';
import PropTypes from 'prop-types';
import {CircularProgress, Grid, Typography} from '@material-ui/core';

const Loader = (props) => {
  const {label} = props;

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      alignItems="center"
      style={{marginTop: '10%', minHeight: '100vh'}}
    >
      <Grid item>
        <Typography variant="h4" style={{color: 'grey'}}>
          {label}
        </Typography>
      </Grid>
      <Grid item>
        <CircularProgress
          size={50}
          left={0}
          top={0}
          style={{margin: '0 auto', position: 'relative', color: '#FF9800'}}
        />
      </Grid>
    </Grid>
  );
};

Loader.propTypes = {
  label: PropTypes.string,
};

Loader.defaultProps = {
  label: 'Loading',
};

export default Loader;
